import React from 'react';
import { navigate } from '@reach/router';

import Avatar from 'components/Avatar/Avatar';
import LinkPreview from 'components/LinkPreview/LinkPreview';
import FeedCommentItemActionMenu from './FeedCommentItemActionMenu';
import CauzeVideo from 'components/CauzeVideo/CauzeVideo';

const FeedCommentItem = ({
  canEdit,
  onImagePress,
  openCommentOptions,
  actions,
  primaryComment,
  id,
  body,
  image,
  video,
  imageUrls,
  previewUrl,
  pageNumber,
  imageId,
  style,
  props,
  onToggleClose,
  uiStore,
}) => {
  const commentImage = image || imageUrls;

  const getSource = () => {
    if (props?.project?.avatarUrls?.sm) {
      return props?.project.avatarUrls.sm;
    }
    if (props?.company?.avatarUrls?.sm) {
      return props?.company.avatarUrls.sm;
    }
    if (props?.user?.avatarUrls?.sm) {
      return props?.user.avatarUrls.sm;
    }
    return '';
  };

  const renderName = () => {
    if (props?.project) return props?.project.name;
    if (props?.company) return props?.company.name;
    if (props?.user?.isCurrentEntity) return 'You';
    return props?.user?.name;
  };

  const handleClick = () => {
    onToggleClose(false);
    if (props?.charityId) {
      navigate(`/charity/${props?.charityId}`);
    }
    if (props?.company && !props?.company?.id?.includes('fake')) {
      navigate(`/company/${props?.company.id}`);
    }

    navigate(`/profile/${props?.user.id}`);
  };

  const renderBodyWithLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);
    return parts.map((part, index) => {
      if (part.match(urlRegex)) {
        const isInternalLink = part.includes(window.location.hostname);
        if (isInternalLink) {
          return (
            <span
              key={index}
              className="text-cauze-dark cursor-pointer hover:underline"
              onClick={() => {
                navigate(new URL(part).pathname);
                onToggleClose(false);
              }}
            >
              {part}
            </span>
          );
        }
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-cauze-dark hover:!text-cauze-dark hover:underline cursor-pointer"
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };

  const renderContent = () => {
    if (video) {
      return (
        <CauzeVideo
          video={video}
          maxHeight={400}
          videoName={`${renderName()}'s Video`}
        />
      );
    }

    if (commentImage?.lg) {
      return (
        <button
          className="comment-image-button"
          onClick={() => onImagePress(commentImage.lg)}
          onContextMenu={
            canEdit
              ? (e) => {
                  e.preventDefault();
                  openCommentOptions({
                    id,
                    body,
                    pageNumber,
                    previewUrl,
                    imagePreviewUrl: commentImage ? commentImage.lg : null,
                    imageId,
                  });
                }
              : null
          }
        >
          <img
            src={commentImage.lg}
            alt="Comment attachment"
            className="comment-image !w-full"
          />
        </button>
      );
    }
  };

  return (
    <div
      className={`feed-comment-item ${primaryComment ? 'primary' : ''}`}
      style={style}
    >
      <div onClick={handleClick} className="avatar-link cursor-pointer">
        <Avatar
          src={getSource()}
          alt={renderName()}
          size={40}
          className="avatar-image"
        />
      </div>
      <div className="comment-content">
        <div className="comment-header">
          <div onClick={handleClick} className="name-link cursor-pointer">
            {renderName()}
          </div>
          <FeedCommentItemActionMenu actions={actions} />
        </div>
        {Boolean(body) && (
          <div className="comment-body ">{renderBodyWithLinks(body)}</div>
        )}

        {Boolean(previewUrl) && (
          <LinkPreview className="link-preview" uri={previewUrl} />
        )}
        {renderContent()}
      </div>
    </div>
  );
};

export default FeedCommentItem;
